import Factory from "./factory";

export default Factory.actions;
